module.exports = __webpack_public_path__ + "static/media/s6.2fe5a005.ogg";